'use strict';
import angular from 'angular';
import xandrInvestLocationHtmlUrl from './views/xandrInvestLocation.list.html';
var app = angular.module('app.xandrInvestLocations.component', []);
app.component('xandrInvestLocationWidget', {
    bindings: {
        selectedXandrGeoLocations : '=',
        clusterId : '=',
        showActions : '='
    },
    templateUrl: xandrInvestLocationHtmlUrl,
    controller: function($scope,$ioAlert, anchorSmoothScroll, $location, $timeout,$stateParams,FormService) {
        var self = this;
        self.orderId = $stateParams.orderId;
        self.rootLocation = { "id": 0, "children": "1", "criteria": "" };
        self.navXandrLocations = [];
        self.previousLocationData = [];
        self.geoLocSearch = "";
        self.breadcrumbs = [];
        self.collectedNodes = [0];
        self.includeOrExcludeLocation = null;
        var geoLocationsCount = 0;
        self.selectedListOfLocations = [];
        self.showTabPanel = true;
        self.selectedInput = {
            value: 'xandr_locations'
        }
        self.geoTextInputs = {
            inputValues: ''
        }
        self.textInputOptions = ["US Postal Codes", "US States"];
        self.textInputObj = {
            textInputType: "US Postal Codes"
        }
        self.selectedCriteria = {
            criteria: ""
        };
        self.criteria = ["include all", "exclude all"];
        self.showError = false;
        self.toggleComponent = function(selectedOption) {
            self.selectedInput.value = selectedOption;
        }
        $scope.$watch('$ctrl.geoTextInputs.inputValues', function() {
            if(self.geoTextInputs.inputValues.length === 0) {
                self.showError = false;
            }
        });
        $scope.$watchCollection('$ctrl.selectedXandrGeoLocations.selXandrLocationPickers', function (newCol) {
            _.map(newCol, function (item) {
                item.selectedInput = "xandr_textInput";
                self.selectedListOfLocations.push(item)
            })
            self.selectedListOfLocations  = _.uniq(self.selectedListOfLocations);
        })
        $scope.$watchCollection('$ctrl.selectedXandrGeoLocations.selXandrTextInputs', function (newCol) {
            _.map(newCol, function (item) { self.selectedListOfLocations.push(item) })
            self.selectedListOfLocations = _.uniq(self.selectedListOfLocations);
        })
        self.handleChangeTextInput = function() {
            self.geoTextInputs.inputValues = '';
            self.showError = false;
        }
        /*
        * Handle validate postal codes
        */
        self.validateInputValues = function () {
            if (self.textInputObj.textInputType === "US Postal Codes") {
                var geoPostalValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
                var filteredPostalValues = geoPostalValues.filter(function (el) {
                    return el !== "";
                });
                FormService.validateXandrPostalCodes(filteredPostalValues, self.clusterId).then(function (data) {
                    if (data) {
                        processTextInputs(data);
                    }
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', error);
                });
            } else if (self.textInputObj.textInputType === "US States") {
                var geoStateValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
                var filteredStateValues = geoStateValues.filter(function (el) {
                    return el !== "";
                });
                FormService.validateXandrUsStates(filteredStateValues, self.clusterId).then(function (data) {
                    if (data) {
                        processTextInputs(data);
                    }
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', error);
                });
            }
        }
        /*
        * Handle process GET response
        */
        var processTextInputs = function(response) {
            if(response.valid && response.valid.length > 0) {
                _.each(response.valid, function(validGeoValue) {
                    validGeoValue.geoType = self.textInputObj.textInputType;
                    validGeoValue.criteria_link = 'included';
                    validGeoValue.criteria= 'include';
                    self.selectedXandrGeoLocations.selXandrTextInputs.push(validGeoValue);
                })
                self.geoTextInputs.inputValues = '';
            }
            if(response.invalid && response.invalid.length > 0){
                self.showError = true;
                self.geoTextInputs.inputValues = response.invalid.toString();
            }
        }
        self.getPostalCodesTooltips=function(selXandrTextInputs){
            var data = angular.copy(selXandrTextInputs);
            data = data.slice(5);
            var html=angular.element("<ul/>");
            angular.forEach(data,function(item){
                var li = angular.element("<li style='list-style:none;'/>");
                li.text(item.name);
                html.append(li);
            });
            return html.html();
        };
        self.getLocationTooltips=function(locations){
            var data = angular.copy(locations);
            data = data.slice(2);
            var html=angular.element("<ul/>");
            angular.forEach(data,function(item){
                var li = angular.element("<li style='list-style:none;'/>");
                li.text(item.full_name);
                html.append(li);
            });
            return html.html();
        };
        /*
        * Handle remove selected text inputs
        */
        self.removeTextInputs = function(removeItem) {
            var selIndex = _.findIndex(self.selectedXandrGeoLocations.selXandrTextInputs, {external_id: removeItem.external_id});
            if (selIndex >= 0) {
                self.selectedXandrGeoLocations.selXandrTextInputs.splice(selIndex, 1);
            }
        }
        /*
        * Handle Clear All Text Inputs
        */
        self.handleClearAllInputs = function() {
            self.selectedXandrGeoLocations.selXandrTextInputs = [];
        }
        self.handleClearSelectedLocations = function() {
            self.selectedXandrGeoLocations.selXandrLocationPickers = [];
            self.selectedXandrGeoLocations.selXandrTextInputs = [];
            self.selectedListOfLocations = [];
            self.selectedCriteria.criteria = 'none';
            geoLocationsCount = 0;
            self.includeOrExcludeLocation = null;
            _.each(self.navXandrLocations, function(navLocation) {
                navLocation.criteria = '';
                navLocation.criteria_link = 'include';
            });
        }
        self.handleChangeCriteria = function() {
            self.selectedXandrGeoLocations.selXandrLocationPickers = [];
            if(self.selectedCriteria.criteria === 'include all') {
                _.each(self.navXandrLocations, function(navLocation) {
                    navLocation.criteria = 'include';
                    navLocation.criteria_link = 'included';
                    navLocation.full_name = self.buildFullName(navLocation);
                    self.selectedXandrGeoLocations.selXandrLocationPickers.push(navLocation);
                });
            } else if(self.selectedCriteria.criteria === 'exclude all') {
                _.each(self.navXandrLocations, function(navLocation) {
                    navLocation.criteria = 'exclude';
                    navLocation.criteria_link = 'excluded';
                    navLocation.full_name = self.buildFullName(navLocation);
                    self.selectedXandrGeoLocations.selXandrLocationPickers.push(navLocation);
                });
            } else {
                _.each(self.navXandrLocations, function(navLocation) {
                    navLocation.criteria = '';
                    navLocation.criteria_link = 'include';
                });
            }
        }
        self.getChildrenNodes = function(item) {
            if (item.children > 0) {
                if (self.collectedNodes.indexOf(item.id) < 0) {
                    FormService.getXandrGeoLocationsById(self.orderId,self.clusterId,item.country_code).then(function(success) {
                        self.collectedNodes.push(item.id);
                        self.locations = self.locations.concat(sortByName(success));
                        self.getLocationChilds(item);
                        self.geoLocSearch = "";
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', error);
                    });
                } else {
                    self.getLocationChilds(item);
                }
            }
        };
        self.showTabPanel = function() {
            self.showTabPanel = !self.showTabPanel;
        }
        self.getLocationChilds = function(item) {
            if (item.children > 0) {
                self.navXandrLocations = [];
                if (self.locations) {
                    for (var i = 0, len = self.locations.length; i < len; i++) {
                        if (self.locations[i].parent_id === item.id) {
                            if (self.selectedXandrGeoLocations.selXandrLocationPickers.length > 0) {
                                var selIndex = _.findIndex(self.selectedXandrGeoLocations.selXandrLocationPickers, { id: self.locations[i].id });
                                if (selIndex !== -1) {
                                    self.locations[i].criteria = self.selectedXandrGeoLocations.selXandrLocationPickers[selIndex].criteria;
                                    self.includeOrExcludeLocation = self.selectedXandrGeoLocations.selXandrLocationPickers[selIndex].criteria + 'location';
                                }
                            } else{
                                self.locations[i].criteria = "";
                            }
                            if (self.locations[i].criteria.length === 0 && item.criteria.length > 0) {
                                self.locations[i].criteria = item.criteria;
                            }
                            self.locations[i].criteria_link = 'include';
                            if (self.locations[i].criteria === "include") {
                                self.locations[i].criteria_link = 'included';
                            } else if (self.locations[i].criteria === "exclude") {
                                self.locations[i].criteria_link = 'excluded';
                            }
                            self.navXandrLocations.push(self.locations[i]);
                            self.checkingCriteria();
                        }
                    }
                    self.previousLocationData = angular.copy(self.navXandrLocations);
                }
                self.breadcrumbs = [];
                self.buildBreadcrumbs(item);
            }
        }
        self.changeIncludeExclude = function(item, criteria) {
            var index = self.navXandrLocations.indexOf(item);
            if (index >= 0) {
                if (criteria === "include") {
                    self.navXandrLocations[index].criteria = 'include';
                    self.navXandrLocations[index].criteria_link = 'included';
                } else if (criteria === "exclude") {
                    self.navXandrLocations[index].criteria = 'exclude';
                    self.navXandrLocations[index].criteria_link = 'excluded';
                } else {
                    self.navXandrLocations[index].criteria = '';
                    self.navXandrLocations[index].criteria_link = 'include';
                }
                if(geoLocationsCount < 1) {
                    self.includeOrExcludeLocation = criteria + 'location';
                }
                var selIndex = _.findIndex(self.selectedXandrGeoLocations.selXandrLocationPickers, { id: self.navXandrLocations[index].id });
                self.navXandrLocations[index].full_name = self.buildFullName(self.navXandrLocations[index])
                if (selIndex >= 0) {
                    self.selectedXandrGeoLocations.selXandrLocationPickers[selIndex] = self.navXandrLocations[index];
                } else {
                    self.selectedXandrGeoLocations.selXandrLocationPickers.push(self.navXandrLocations[index]);
                }
                changeAllChildCriteria(self.navXandrLocations[index].id, self.navXandrLocations[index].criteria);
                for(var i=0; i<self.selectedXandrGeoLocations.selXandrLocationPickers.length; i++){
                    var parentId = parseInt(self.selectedXandrGeoLocations.selXandrLocationPickers[i].parent_id);
                    var parentObj = _.find(self.locations, {id: parentId});
                    if(parentObj && parentObj.criteria === self.selectedXandrGeoLocations.selXandrLocationPickers[i].criteria ){
                        self.selectedXandrGeoLocations.selXandrLocationPickers.splice(i, 1);
                    }
                }
                geoLocationsCount++;
            }
        }
        self.removeLoc = function (item) {
            if (item.selectedInput === "xandr_textInput") {
                var selIndex = self.selectedXandrGeoLocations.selXandrLocationPickers.indexOf(item);
                self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
                if (selIndex >= 0) {
                    self.selectedXandrGeoLocations.selXandrLocationPickers.splice(selIndex, 1);
                    if (self.selectedXandrGeoLocations.selXandrLocationPickers.length === 0) {
                        geoLocationsCount = 0;
                        self.includeOrExcludeLocation = null;
                    }
                }
                var parentId = parseInt(item.parent_id);
                var parentLocation = _.find(self.locations, { id: parentId });
                var locationObj = _.find(self.locations, { id: item.id });
                if (locationObj) {
                    if (parentLocation) {
                        if (parentLocation.criteria === "include") {
                            locationObj.criteria = 'include';
                            locationObj.criteria_link = 'included';
                        } else if (parentLocation.criteria === "exclude") {
                            locationObj.criteria = 'exclude';
                            locationObj.criteria_link = 'excluded';
                        } else {
                            locationObj.criteria = '';
                            locationObj.criteria_link = 'include';
                        }
                    } else {
                        locationObj.criteria = '';
                        locationObj.criteria_link = 'include';
                        for (var j = 0; j < self.navXandrLocations.length; j++) {
                            if (self.navXandrLocations[j].name === item.name) {
                                self.navXandrLocations[j].criteria = '';
                                self.navXandrLocations[j].criteria_link = 'include';
                                break;
                            }
                        }
                        self.previousLocationData = angular.copy(self.navXandrLocations);
                    }
                    changeAllChildCriteria(item.id, locationObj.criteria);
                } else {
                    for (var k = 0; k < self.navXandrLocations.length; k++) {
                        if (self.navXandrLocations[k].name === item.name) {
                            self.navXandrLocations[k].criteria = '';
                            self.navXandrLocations[k].criteria_link = 'include';
                            break;
                        }
                    }
                }
                for (var i = 0; i < self.selectedXandrGeoLocations.selXandrLocationPickers.length; i++) {
                    if (self.selectedXandrGeoLocations.selXandrLocationPickers[i].parent_id === String(item.id)) {
                        self.selectedXandrGeoLocations.selXandrLocationPickers.splice(i, 1);
                    }
                }
            } else {
                var selIndex = _.findIndex(self.selectedXandrGeoLocations.selXandrTextInputs, {id: item.id});
                if (selIndex >= 0) {
                    self.selectedXandrGeoLocations.selXandrTextInputs.splice(selIndex, 1);
                    self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
                }
            }
        }
        function changeAllChildCriteria(parentId, criteria = ""){
            _.each(self.locations, function(location){
                if(location.parent_id === parentId){
                    if(criteria === "include"){
                        location.criteria = 'include';
                        location.criteria_link = 'included';
                    }else if(criteria === "exclude"){
                        location.criteria = 'exclude';
                        location.criteria_link = 'excluded';
                    }else{
                        location.criteria = '';
                        location.criteria_link = 'include';
                    }
                    changeAllChildCriteria(location.id, location.criteria);
                }
            });
        }

        self.searchXandrLocation = function (geoLocSearch) {
            if (event.keyCode !== 13) {
                var cacheKey = 'cachedXandrSearchData';
                var cacheExpirationKey = 'cacheXandrExpiration';
                var cacheExpirationTime = 7 * 24 * 60 * 60 * 1000;
                var currentTime = new Date().getTime();
                var cachedData = JSON.parse(localStorage.getItem(cacheKey)) || [];
                var cacheExpiration = parseInt(localStorage.getItem(cacheExpirationKey)) || 0;

                if (currentTime > cacheExpiration) {
                    cachedData = [];
                    localStorage.removeItem(cacheKey);
                    localStorage.removeItem(cacheExpirationKey);
                }
                function filterData(data, searchTerm) {
                    if (!Array.isArray(data)) {
                        console.error("filterData received invalid data:", data);
                        return [];
                    }
                    return data.filter(item => item.name?.toLowerCase().includes(searchTerm.toLowerCase()));
                }
                if (geoLocSearch.length > 0) {
                    var filteredCachedData = filterData(cachedData, geoLocSearch);
                    if (filteredCachedData.length > 0) {
                        self.searchData = filteredCachedData;
                        processData(self.searchData);
                    } else {
                        FormService.getXandrGeoSearchloctions(geoLocSearch, self.clusterId).then(function (success) {
                            self.searchData = sortByName(success);
                            localStorage.setItem(cacheKey, JSON.stringify(self.searchData));
                            var newCacheExpiration = currentTime + cacheExpirationTime;
                            localStorage.setItem(cacheExpirationKey, newCacheExpiration.toString());
                            var filteredData = Array.isArray(self.searchData) ? filterData(self.searchData, geoLocSearch) : [];
                            processData(filteredData);
                        }, function (error) {
                            console.error("API Error:", error);
                        });
                    }
                } else {
                    // Handle empty search query
                    self.searchData = [];
                    self.navXandrLocations = [];
                    self.navXandrLocations = angular.copy(self.previousLocationData);
                    self.checkingCriteria();
                }
            }
            function processData(data) {
                self.navXandrLocations = [];
                _.each(data, function (item, i) {
                    var index = self.locations.findIndex(x => x.id === item.id);
                    if (index > -1) {
                        self.navXandrLocations.push(self.locations[index]);
                    } else {
                        self.navXandrLocations[i] = item;
                        self.navXandrLocations[i].criteria = item.criteria;
                        self.navXandrLocations[i].criteria_link = 'include';
                        self.navXandrLocations[i].name = item.name;
                        self.navXandrLocations[i].parent_name = item.parent_name;
                        self.navXandrLocations[i].region_name = item.region_name;
                    }
                });
                self.checkingCriteria();
            }
        };
        self.checkingCriteria = function(){
            for(var k=0;k<self.selectedXandrGeoLocations.selXandrLocationPickers.length;k++){
                for(var j=0;j<self.navXandrLocations.length;j++){
                    if(self.selectedXandrGeoLocations.selXandrLocationPickers[k].name === self.navXandrLocations[j].name){
                        if (self.selectedXandrGeoLocations.selXandrLocationPickers[k].criteria === "include") {
                            self.navXandrLocations[j].criteria = 'include';
                            self.navXandrLocations[j].criteria_link = 'included';
                        } else if (self.selectedXandrGeoLocations.selXandrLocationPickers[k].criteria === "exclude") {
                            self.navXandrLocations[j].criteria = 'exclude';
                            self.navXandrLocations[j].criteria_link = 'excluded';
                        }else{
                            self.navXandrLocations[j].criteria = '';
                            self.navXandrLocations[j].criteria_link = 'include';
                        }
                    }
                }
            }
        }
        self.buildBreadcrumbs = function(item) {
            if (item.parent_id || item.parent_id === 0) {
                self.breadcrumbs.unshift(item);
                if (item.parent_id === 0) {
                    return false;
                } else {
                    var obj = _.find(self.locations, function(loc) {
                        return loc.id === item.parent_id
                    });
                    self.buildBreadcrumbs(obj);
                }
            }
        }
        self.buildFullName = function(item) {
            if (item.parent_id === 0) {
                return item.name + ".";
            } else {
                var obj = _.find(self.locations, function(loc) {
                    return loc.id === item.parent_id
                });
                if(obj === undefined && item.parent_name){
                    return item.name + " , " + item.parent_name +"."
                } else {
                    return item.name + ", " + self.buildFullName(obj);
                }
            }
        }
        let getLocations = function() {
            FormService.getXandrGeoLocationsById(self.orderId,self.clusterId,null).then(function(success) {
                self.locations = sortByName(success);
                self.getLocationChilds(self.rootLocation);
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', error);
            });
        };
        let sortByName = function(data) {
            if (!Array.isArray(data)) {
                console.error("sortByName: Expected an array, received:", data);
                return [];
            }
            return data.sort((a, b) => a.name.localeCompare(b.name));
        };

        let initLocations = function() {
            if(self.selectedXandrGeoLocations && !_.isEmpty(self.selectedXandrGeoLocations)){
                self.selectedXandrGeoLocations = JSON.parse(self.selectedXandrGeoLocations);
                if(self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    getLocations();
                    if(self.selectedXandrGeoLocations.selXandrTextInputs && self.selectedXandrGeoLocations.selXandrTextInputs.length > 0){
                        self.textInputObj.textInputType = self.selectedXandrGeoLocations.selXandrTextInputs[0].geoType ? self.selectedXandrGeoLocations.selXandrTextInputs[0].geoType : "US Postal Codes";
                    }
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedXandrGeoLocations = {
                    selXandrLocationPickers: [],
                    selXandrTextInputs: []
                };
                self.enableViewMode = false;
                self.editMode = false;
                getLocations();
            }
        };
        initLocations();
    }
});